// eslint-disable-next-line import/prefer-default-export
export const MEDIA_TYPES = { IMAGE: 'IMAGE', VIDEO: 'VIDEO' };

export const GENDERS_NOT_FOUND = 'Genders for this content are not available';
export const COUNTRIES_NOT_FOUND =
  'Countries for this content are not available';
